import React, { Component } from 'react';

const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/tour/';


export default class TravelPage extends Component {
    // constructor() {
    //     super()
      
    // }

    AddSpecialChar = (str) => {
        if (str !== '' && str !== undefined && str !== null)
            return str.replace(/pnk_Amp/g, "&");
    }

    Duration = (str) => {

        if (str !== '' && str !== undefined && str !== null)
            str.replace(/pnk_Amp/g, "&");
           let result =  str.slice(0 , str.indexOf('/'))
           // alert(str)

            return result;

    }

    TourImage = (img)=>{

      //  alert(img)
      let result = img.slice(0, img.indexOf(','))
      return img_path+result;

    }

    render() {
        return (
            <div className='travel-main'>
                <div className='container-fluid'>
                    <div className='travel-heading'>
                        <h3>Tour Packages</h3>
                    </div>
                    <div className='travel-list-main'>
                        <div className='row'>
                            {this.props.mystate.tourlist.length > 0 ?
                                this.props.mystate.tourlist.map((item) =>
                                    <div className='col-12 col-sm-6 col-md-6 col-lg-4'>
                                        <div className='card travel-list-main-card' onClick={() => this.props.HandleRouting(`tour-details/${item.tour_seo_url}`)}>
                                            <div className='travel-list-card-img'>
                                                <div className='travel-list-card-info-duration'>
                                                    <p>{this.Duration(item.tour_duration)}</p>
                                                </div>

                                                <img src={this.TourImage(item.tour_image)} alt='loading...' />
                                                <div className='travel-list-card-info'>
                                                    <p>{item.tour_theme}</p>

                                                </div>

                                            </div>
                                            <div className='travel-list-content'>
                                                <div className='travel-list-content-head'>
                                                    <h6>{this.AddSpecialChar(item.tour_name)}</h6>
                                                </div>
                                                <div className='travel-list-content-info'>
                                                {item.tour_flight === 0 || item.tour_flight === '0'?

                                                    <p>Flight not included</p>
                                                :<p style={{color:'green'}}>Flight included</p>
                                            }
                                                    <div style={{ display: 'flex' }}>
                                                        <i class='fa fa-map-marker'></i>
                                                        <h6>{this.AddSpecialChar(item.tour_cities)}</h6>
                                                    </div>
                                                </div>
                                                <div className='travel-list-seperation-thin'>
                                                </div>
                                                <div className='travel-list-price-info'>
                                                    <div style={{ display: 'flex' }}>
                                                        <i class='fa fa-rupee'></i>
                                                        <h3>{item.tour_pricing}</h3>
                                                        <button type='button' className='btn' onClick={() => this.props.HandleRouting(`tour-details/${item.tour_seo_url}`)}>Details</button>
                                                    </div>
                                                    <p>per person, onwards</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                )

                                : ''}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

